module.exports = __webpack_public_path__ + "img/Emas Persada Finance.cd1813c7.png";